import React, { useState } from "react";
import rosette from "../../assets/images/rosette.png";

const PMSColorRibbonTwo = ({
  randomColorsRibbonTwo,
  colorChangeRibbonTwo,
  colorPickerSelectedColor2,
}) => {
  const [isEnabled, setIsEnabled] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsEnabled(event.target.checked);
    if (!event.target.checked) {
      colorChangeRibbonTwo("");
    }
  };

  const handleColorClick = (colorValue, name) => {
    if (isEnabled) {
      colorChangeRibbonTwo(colorValue, name);
    }
  };

  return (
    <div className="p-6 max-w-4xl m-4 border border-gray bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg shadow-md">
      <div className="flex items-center gap-2 mb-6 bg-white/50 rounded-lg p-2">
        <h2 className="text-lg font-medium text-gray-700">
          SECONDARY COLOR CHOICE
        </h2>
      </div>
      <label className="flex items-center gap-2 mb-6 cursor-pointer">
        <input
          type="checkbox"
          checked={!!isEnabled}
          onChange={handleCheckboxChange}
          className={`w-5 h-5 border-2 border-gray-300 rounded ${
            isEnabled ? "border-purple-700" : ""
          }`}
        />
        <span className="text-gray-700">Secondary color choice</span>
      </label>

      <div
        className={`grid grid-cols-5 gap-4 h-48 ps-[0.9rem] pe-[0.8rem] overflow-y-auto overflow-x-hidden custom-scrollbar ${
          !isEnabled ? "opacity-50 pointer-events-none" : ""
        }`}
      >
        {randomColorsRibbonTwo.map((color, index) => (
          <div
            key={index}
            className={`flex flex-col items-center px-2 pb-2  rounded-lg transition-all duration-300 ${
              colorPickerSelectedColor2 === color.name && "bg-[#aaa9a7]"
            }`}
            onClick={() => handleColorClick(color.value, color.name)}
          >
            <div
              className={`relative w-10 h-10  overflow-hidden group ${
                !isEnabled ? "cursor-not-allowed" : "cursor-pointer"
              }`}
              style={{
                backgroundImage: `url(${color.icon})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></div>
            <span
              className="text-[0.65rem] text-center  text-gray-500 mt-1"
              style={{ lineHeight: "0.8rem" }}
            >
              {color.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PMSColorRibbonTwo;
